'use strict';

module.exports = require('./components/TinyMCE');


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tinymce/lib/main.js
 ** module id = 192
 ** module chunks = 1 2 4 6 8 9 11
 **/